import { Box } from '@modusign/design-system';
import PropTypes from 'prop-types';
import PropsType from 'props-type';

import SignatureTypeSelectListItem from './SignatureTypeSelectListItem';

const propTypes = {
  order: PropTypes.number,
  onSelect: PropTypes.func,
};

const defaultProps = {
  order: 1,
  onSelect(_t: string) {},
};

type SignatureTypeSelectListProps = PropsType<typeof propTypes, typeof defaultProps>;

function SignatureTypeSelectList({ order, onSelect }: SignatureTypeSelectListProps) {
  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          backgroundColor: 'white',
          border: '1px solid',
          borderColor: 'lightGray300',
          borderRadius: '4px',
          boxShadow: '1px 2px 6px 0 rgba(0, 0, 0, 0.1)',
          left: 0,
          marginTop: 0,
          minWidth: 184,
          overflow: 'hidden',
          position: 'absolute',
          textAlign: 'left',
          top: 0,
          width: '100%',
          zIndex: 1,
        }}
      >
        <Box
          as="ul"
          sx={{
            position: 'relative',
            width: '100%',
          }}
        >
          <SignatureTypeSelectListItem
            iconSize={16}
            order={order}
            type="SIGN_OR_STAMP"
            onSelect={onSelect}
          />
          <SignatureTypeSelectListItem
            iconSize={14}
            order={order}
            type="SIGN"
            onSelect={onSelect}
          />
          <SignatureTypeSelectListItem
            iconSize={14}
            order={order}
            type="STAMP"
            onSelect={onSelect}
          />
        </Box>
      </Box>
    </Box>
  );
}

SignatureTypeSelectList.propTypes = propTypes;
SignatureTypeSelectList.defaultProps = defaultProps;

export default SignatureTypeSelectList;
